/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { routes } from '@builddocs/data-management'
import { Button, Box, Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import SignInForm from './SignInForm'

type Props = {
  isDevEnvironment?: boolean
  onRedirect: () => void
}

export function WhiteBox({ onRedirect }: Props) {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
          width: 300,
        }}
      >
        <Typography
          gutterBottom
          align="center"
          component="div"
          fontWeight="400"
          marginBottom={6}
          variant="h4"
        >
          Вход
        </Typography>
        <SignInForm />
        <Box
          mt={1}
          pb={2}
          sx={{
            mt: 1,
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: '20px',
          }}
        >
          Нет учетной записи?
          <Link
            component={RouterLink}
            sx={{ pl: 1 }}
            to={routes.auth.signUp()}
            underline="hover"
          >
            Зарегистрироваться
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
          width: 300,
          mt: 4,
        }}
      >
        <Typography
          align="center"
          component="div"
          fontWeight="400"
          mb={2}
          variant="h6"
        >
          Партнерский вход
        </Typography>
        <Button
          sx={{
            py: 1.5,
            px: 1,
            bgcolor: '#EAEEF8',
            color: '#000',
            textTransform: 'none',
            fontSize: 14,
          }}
          onClick={() => {
            localStorage.setItem('REALM', 'OSNOVA')
            onRedirect()
          }}
        >
          Войти через Основу
        </Button>
        <Button
          sx={{
            mt: 2,
            py: 1.5,
            px: 1,
            bgcolor: '#EAEEF8',
            color: '#000',
            textTransform: 'none',
            fontSize: 14,
          }}
          onClick={() => {
            localStorage.setItem('REALM', 'PIK')
            window.location.href = '/api/oauth/authorize/pik'
          }}
        >
          Войти через ПИК
        </Button>
        {/*<Button*/}
        {/*  sx={{*/}
        {/*    mt: 2,*/}
        {/*    py: 1.5,*/}
        {/*    px: 1,*/}
        {/*    bgcolor: '#EAEEF8',*/}
        {/*    color: '#000',*/}
        {/*    textTransform: 'none',*/}
        {/*    fontSize: 14,*/}
        {/*  }}*/}
        {/*  onClick={() => {*/}
        {/*    localStorage.setItem('REALM', 'LEVEL')*/}
        {/*    window.location.href = '/api/oauth/authorize/level'*/}
        {/*  }}*/}
        {/*>*/}
        {/*  Войти через Level*/}
        {/*</Button>*/}
      </Box>
    </>
  )
}
